import { render, staticRenderFns } from "./PageModal.vue?vue&type=template&id=6d8e07c8"
import script from "./PageModal.vue?vue&type=script&lang=js"
export * from "./PageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports